import { render, staticRenderFns } from "./thread-file-upload.vue?vue&type=template&id=81b22106&scoped=true&"
import script from "./thread-file-upload.vue?vue&type=script&lang=js&"
export * from "./thread-file-upload.vue?vue&type=script&lang=js&"
import style0 from "./thread-file-upload.vue?vue&type=style&index=0&id=81b22106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b22106",
  null
  
)

component.options.__file = "thread-file-upload.vue"
export default component.exports